<script>
    import NavBar from "../components/NavBar.svelte";
    import Foot from "../components/Foot.svelte";
</script>

<NavBar/>

<main class="page-main">
    <h1>Goosicorn</h1>
    <div class="goose">
    </div>
</main>

<Foot/>

<style>
    main {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 85vh;
    }

    h1 {
        font-family: 'Pacifico', cursive;
        font-size: 4rem;
        margin: -100px 0 0;
    }

    .goose {
        user-select: none;
        margin: 0 auto;
        background-image: url("../assets/goosicorn.svg");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: 25px 10px;
        width: 300px;
        height: 300px;
        border: black solid 3px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: 5px 5px;
    }

    .goose:active {
        transform: translate(5px, 5px);
        box-shadow: 0 0;
        background-image: url("../assets/goosicorn-excited.svg");
    }
</style>
